import React from 'react'
import styles from './PopupApprove.module.scss'
import { Modal } from 'components/Modal/Modal'
import { Icon } from 'components/Icon/Icon'
import { Button } from 'components/Button/Button'
import { Link } from 'react-router-dom'

type Props = {
    onClose: () => void,
    onApprove: () => void
}

export function PopupApprove(props: Props) {

    const isSucces = true

    function onSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
    }

    return (
        <Modal onClose={props.onClose}>
            <form className={styles['wrapper']} onSubmit={onSubmit}>
                <div className={styles['saving']}>
                    <Icon name={isSucces ? 'collect' : 'rejected'} />
                </div>
                <div>
                    {isSucces ? (
                        <div className={styles['content']}>
                            <span className={styles['title']}>Set allowance</span>
                            <span className={styles['description']}>
                                Drizzle needs your approval to move funds in order to make a deposit.
                                Please accept in Metamask.
                                <Link to='/' className={styles['link']}> Read more about allowance</Link>
                            </span>
                        </div>
                    ) : (
                        <div className={styles['content']}>
                            <span className={styles['title']}>
                                You rejected approval transaction. Please sign with Metamask
                            </span>
                        </div>
                    )}
                </div>
                <div className={styles['button']}>
                    <Button size='l' type='border' stretch={false} onClick={props.onClose}>
                        Cancel
                    </Button>
                    <Button size='l' type='dark' onClick={props.onApprove}>
                        Approve USDC
                    </Button>
                </div>
            </form>
        </Modal>
    )
}

